var _defs, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2500,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: "100%"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 256,
    height: 256,
    rx: 25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "rgba(94, 0, 53, 1)",
    x: 144.64,
    y: 33.28,
    width: 78.08,
    height: 112,
    rx: 12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "rgba(94, 0, 53, 1)",
    x: 33.28,
    y: 33.28,
    width: 78.08,
    height: 176,
    rx: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrello);
export default __webpack_public_path__ + "static/media/trello.a6236d5978e3dbc6aba3d8f869411c79.svg";
export { ForwardRef as ReactComponent };